export const statusEnum = {
  1: "待审核",
  3: "跟进中",
  // 6: "待签署",
  // 7: "待完成",
  // 80: "发货中",
  9:'待完结',
  100: "完成",
  110: "失效"
};

export const statusEnumList = (() => {
  let list = [
    {
      key: "",
      value: "全部"
    }
  ];
  Object.keys(statusEnum).forEach(key => {
    list.push({
      key: key,
      value: statusEnum[key]
    });
  });
  return list;
})();

export const statusDetail = {
  1: {
    label: "订单待审核",
    color: "#FF3600"
  },
  3: {
    label: "业务员跟进中",
    color: "#FF3600"
  },
  6: {
    label: "订单待签署",
    color: "#FF3600"
  },
  7: {
    label: "订单待完成",
    color: "#FF3600"
  },
  9: {
    label: "订单待完成",
    color: "#FF3600"
  },
  // 80: {
  //   label: "发货中",
  //   color: "#FF3600"
  // },
  100: {
    label: "订单已完成",
    color: "green"
  },
  110: {
    label: "失效",
    color: "#ABABAB"
  }
};
